import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    'id': {
        isForgotPassword: 'Lupa kata sandi',
        clickLogin: 'Masuk',
        isPassword: 'Kata sandi',
        isStaffId: 'Staff ID',
        loginWelcome: 'Masuk ke ERP',
        loginDesc1: 'Selamat Datang Di Sistem ERP',
        loginDesc2: 'Jadikan Pekerjaan Anda Lebih Mudah dan Menyenangkan',
        dashboard: 'Dasbor',
        attendance: 'Kehadiran',
        leave: 'Cuti',
        reimbursement: 'Pengembalian Dana',
        masterData: 'Data Master',
        company: 'OPD/Dinas',
        branch: 'Bidang/Bagian',
        department: 'SubBag/Seksi',
        employee: "Pegawai",
        overtime: 'Lembur',
        settings: 'Pengaturan',
        employmentType: 'Pangkat/Golongan',
        position: 'Posisi',
        startWork: 'Tanggal Mulai Kerja',
        document: 'Dokumen',
        searchDate: 'Cari berdasarkan tanggal',
        searchMonth: 'Cari berdasarkan bulan',
        searchYear: 'Cari berdasarkan tahun',
        searchName: 'Cari berdasarkan nama',
        today: 'hari ini',
        clear: 'Bersihkan',
        filter: 'Filter',
        on: 'pada',
        name: 'Nama',
        status: 'Status',
        startBreak: 'Mulai istirahat',
        endBreak: 'Selesai istirahat',
        outStation: 'Dinas luar',
        clockin: 'Jam masuk',
        clockout: 'Jam keluar',
        totalLate: 'Jumlah terlambat (menit)',
        totalHour: 'Jumlah jam',
        detail: 'Rincian',
        back: 'Kembali',
        minutes: 'menit',
        date: 'Tanggal',
        noReport: 'tidak ada laporan hari ini',
        noFilled: 'Belum mengisi absensi hari ini :(',
        access: "Akses",
        setAttendance: "Kehadiran",
        leaveType: "Jenis Cuti",
        photoCate: "Kategori Foto",
        reimbursementType: "Jenis Pengembalian Dana",
        breakHour: "Jumlah Jam Istirahat",
        clockInPic: "Foto jam masuk",
        clockOutPic: "Foto jam keluar",
        clockOutLoc: "Lokasi jam keluar",
        clockInLoc: "Lokasi jam masuk",
        clock_in: "Masuk",
        clock_out: "Keluar",
        break: "Istirahat",
        no_status: "Tidak ada status",
        export_attendance_report: 'Ekspor laporan kehadiran',
        select_date: "Pilih tanggal ( harian )",
        select_month_year: "Pilih bulan & tahun ( bulanan )",
        to_pdf_d: "Ekspor ke PDF (harian)",
        to_pdf_m: "Ekspor ke PDF (bulanan)",
        to_exc_d: "Ekspor ke Excel (harian)",
        to_exc_m: "Ekspor ke Excel (bulanan)",
        exportExcel: "Ekspor ke Excel",
        today_report: "Laporan hari ini",
        histories: "Riwayat",

        // cuti
        employeeName: "Nama Pegawai",
        approvedBy: "Disetujui oleh",
        requestedBy: "Diminta oleh",
        rejectedBy: 'Ditolak oleh',
        dateRange: "Rentang tanggal",
        type: "Jenis",
        req: "Diminta",
        appr: "Disetujui",
        rej: "Ditolak",
        can: "Dibatalkan",
        start_date: "Tanggal mulai",
        end_date: "Tanggal selesai",
        days: "Hari",
        note: "Catatan",
        exceedQuota: "Melebihi batas cuti",
        START: "Mulai",
        END: "Selesai",
        CREATED: 'Dibuat',
        NOTE: 'Catatan',
        photo: 'Foto',
        leaveHistoryStatus: 'Riwayat status cuti',
        changeBy: "Diubah oleh",
        time: "Waktu",
        REJECT: 'Menolak',
        APPROVE: 'Menyetujui',
        appReimburst: 'Pengembalian yang disetujui',
        paidReimburst: 'Pengembalian yang dibayar',
        reimburstCategory: "Kategori Pengembalian",
        search: "Cari",
        categories: "Kategori",
        amount: 'Jumlah',
        noRequest: "Nomor permintaan",
        requestBy: "Diminta oleh",
        reqReimburst: 'Permintaan pengembalian',
        requestCategories: 'Kategori Permintaan',
        journalAcc: 'Akun Jurnal',
        reimburstHistoriesStatus: 'Riwayat status pengembalian dana',
        description: 'Deskripsi',
        receiptDate: 'Tanggal Kwitansi',
        paid: 'Dibayar',
        totalPay: 'Total pembayaran',
        pay: 'Bayar',
        detailApproved: 'Rincian yang disetujui',
        approveDate: 'Tanggal disetujui',
        payReimbursement: 'Pembayaran pengembalian',
        paymentDate: 'Tanggal pembayaran',
        payRefNumber: 'Nomor ref pembayaran',
        paidFrom: 'Dibayar dari',
        paidBy: 'Dibayar oleh',
        paidTime: 'Dibayar tanggal',
        reqDate: 'Tanggal diminta',
        approvedBy: 'Disetujui oleh',
        approvedTime: 'Tanggal disetujui',
        paidBy: 'Dibayar oleh',
        paidNote: 'Catatan',
        selectAccJournal: 'Pilih Akun Jurnal',
        addCategories: 'Tambah Kategori',
        nameCategory: 'Nama kategori',
        addCategoryIcon: "Tambah ikon kategori",
        add: 'Tambah',
        categoryIcon: 'Ikon Kategori',
        listCategory: 'Daftar Kategori',
        address: 'Alamat',
        telephone: 'Telepon',
        companyNotif: 'Berhasil ditambahkan!',
        companyNotifUpdate: 'Berhasil diperbaharui!.',
        ishqAddress: 'ALAMAT KANTOR PUSAT',
        location: 'Lokasi',
        useGeofence: 'Gunakan Geofence',
        searchByCompany: 'Cari berdasarkan OPD',
        questionGeo: 'Gunakan Geofence untuk Bidang (Bagian) ?',
        reqList: 'Daftar Permintaan',
        save: 'Simpan',
        selectCompany: 'Pilih Organisasi Perangkat Daerah',
        selectBranch: 'Pilih Bidang ( bagian )',
        selectDepartment: 'Pilih SubBag / Seksi',

        // employee
        nip: 'NIP',
        managementAccount: "Pengelolaan Akun",
        username: 'username',
        email: 'email',
        employeeInfo: "Info Pegawai",
        firstName: 'Nama Depan',
        lastName: 'Nama Belakang',
        nickName: 'Nama Panggilan',
        identityNumber: 'Nomor Identitas',
        driverLicense: 'SIM',
        dob: 'Tanggal Lahir',
        placeofbirth: 'Tempat Lahir',
        bloodType: 'Golongan Darah',
        selectBlood: 'Pilih Golongan Darah',
        selectGender: 'Pilih Jenis Kelamin',
        selectMarital: 'Pilih Status Perkawinan',
        single: 'Lajang',
        married: 'Menikah',
        divorced: 'Cerai',
        widowed: 'Janda / Duda',
        gender: 'Jenis Kelamin',
        maritalStatus: 'Status Perkawinan',
        contactInfo: 'Info Kontak',
        phone: 'Telepon',
        workPhone: 'Telepon Kantor',
        workEmail: 'Email Kerja',
        currentAddress: 'Alamat saat ini',
        emergencyContact: 'Kontak darurat',
        primaryContact: 'Kontak utama',
        secondaryContact: 'Kontak kedua',
        previous: 'sebelumnya',
        next: 'selanjutnya',
        education: 'Pendidikan',
        lvlOfEducation: 'Tingkat Pendidikan',
        nameOfUniversity: 'Nama Universitas / Sekolah',
        graduatedYear: 'Tahun Lulus',
        employment: 'Pekerjaan',
        jobDesc: '  Deskripsi Pekerjaan',
        leaveQouta: 'Kuota',
        male: 'Laki - laki',
        female: 'Perempuan',
        selectRelation: 'Pilih hubungan',
        Parent: "Orang tua",
        Child: "Anak",
        Brother: "Saudara Laki - laki",
        Sister: "Saudara Perempuan",
        Nephew: "Keponakan Laki - laki",
        Niece: "Keponakan Perempuan",
        Cousin: "Sepupu",
        selectLvlEducation: 'Pilih Tingkat Pendidikan',
        DoctoralDegree: 'Gelar Doktor',
        MastersDegree: "Gelar Master",
        BachelorsDegree: "Gelar Sarjana",
        AssociateDegree: "Gelar Asosiasi",
        SeniorHighSchool: "SMA",
        selectEmploymentType: "Pilih Pangkat/Golongan",
        //sETTINGS
        access: 'Akses',
        role: 'Wewenang',
        createdBy: 'Dibuat oleh',
        remove: 'Hapus',
        addAccess: 'Tambahkan Aksess',
        startWorkTime: 'Jam masuk kerja',
        endWorkTime: 'Jam pulang kerja',
        offDay: 'Libur',
        Day: 'Hari',
        Monday	: 'Senin',
        Tuesday: 'Selasa',
        Wednesday: 'Rabu',
        Thursday: 'Kamis',	
        Friday	: "Jum'at",
        Saturday: 'Sabtu',
        Sunday: 'Minggu',
        leavePhoto: 'Apakah butuh foto ?',
        selectRole: 'Pilih wewenang',
        createdAt: 'Dibuat pada',
        letter: "Surat",
        letterNumber: "Nomor Surat",
        letterDate: "Tanggal Surat",
        letterType: "Jenis Surat",
        letterPurpose: "Tujuan Surat",
        letterStartDate: "Tanggal Mulai",
        letterEndDate: "Tanggal Selesai",
        letterOfAssignmentAttachments: "Lampiran Surat Tugas"
    },
    'en': {
        isForgotPassword: 'Forgot Password',
        clickLogin: 'Login',
        isPassword: 'Password',
        isStaffId: 'Staff ID',
        loginWelcome: 'Login to ERP',
        loginDesc1: 'Welcome To ERP System',
        loginDesc2: 'Make Your Work Easier and Fun',
        dashboard: 'Dashboard',
        attendance: 'Attendance',
        leave: 'Leave',
        reimbursement: 'Reimbursement',
        masterData: 'Master Data',
        company: 'Company',
        branch: 'Branch',
        overtime: 'Overtime',
        department: 'Departme   nt',
        employee: "Employee",
        settings: 'Settings',
        employmentType: 'Employment Type',
        position: 'Position',
        startWork: 'Start Work',
        document: 'Document',
        searchDate: 'Search by date',
        searchMonth: 'Search by month',
        searchYear: 'Search by year',
        searchName: 'Search by name',
        today: 'today',
        clear: 'Clear',
        filter: 'Filter',
        on: 'on',
        name: 'Name',
        status: 'Status',
        outStation: 'Outstation',
        clockin: 'Clock in',
        clockout: 'Clock out',
        totalLate: 'Total late',
        totalHour: 'Total hour',
        startBreak: 'Start break',
        endBreak: 'End break',
        detail: 'Detail',
        back: 'Back',
        minutes: 'minutes',
        noReport: 'no report today',
        noFilled: "Haven't filled out today's attendance :(",
        outStation: "Out Station",
        date: 'Date',
        access: "Access",
        setAttendance: "Attendance",
        leaveType: "Leave type",
        photoCate: "Photo category",
        reimbursementType: "Reimbursement type",
        breakHour: "Total Break Hour",
        clockInPic: "Clock-in picture",
        clockOutPic: "Clock-out picture",
        clockOutLoc: "Clock-in Location",
        clockInLoc: "Clock-out Location",
        clock_in: "CLOCK IN",
        clock_out: "CLOCK OUT",
        break: "BREAK IN",
        no_status: "NO STATUS",
        export_attendance_report: 'Export Attendance Report',
        select_date: "SELECT DATE ( DAILY )",
        select_month_year: "SELECT MONTH & YEAR ( MONTHLY )",
        to_pdf_d: "Export to PDF (daily)",
        to_pdf_m: "Export to PDF (monthly)",
        to_exc_d: "Export to Excel (daily)",
        to_exc_m: "Export to Excel (monthly)",
        today_report: "Report today",
        histories: "Histories",
        exportExcel: "Export to Excel",
        employeeName: "Employee",
        approvedBy: "Approved by",
        requestedBy: "Requested by",
        rejectedBy: 'Rejected by',
        dateRange: "Date Range",
        type: "Jenis",
        req: "Requested",
        appr: "Approved",
        rej: "Rejected",
        can: "Canceled",
        start_date: "Tanggal mulai",
        end_date: "Tanggal selesai",
        days: "Hari",
        note: "Catatan",
        exceedQuota: "Exceed Quota of Leave",
        START: "Start",
        END: "End",
        CREATED: 'Created',
        createdAt: 'Created at',
        createdBy: 'Created by',
        NOTE: 'Note',
        photo: 'Photo',
        leaveHistoryStatus: 'Leave Status History',
        changeBy: "Change by",
        time: 'Time',
        REJECT: 'Reject',
        APPROVE: 'Approve',
        reqReimburst: 'Requested Reimbursement',
        appReimburst: 'Approved reimbursement',
        paidReimburst: 'Paid reimbursement',
        reimburstCategory: "Reimbursement category",
        search: 'Search',
        categories: "Category",
        amount: 'Amount',
        noRequest: "Request number",
        requestBy: "Requested by",
        requestCategories: 'Requested Category',
        journalAcc: 'JOURNAL ACCOUNT',
        reimburstHistoriesStatus: 'Reimbursement Status History',
        description: 'Description',
        receiptDate: 'Receipt date',
        paid: 'Paid',
        totalPay: 'Total payment',
        pay: 'Pay',
        detailApproved: 'Detail Approved',
        approveDate: 'Approved date',
        payReimbursement: 'Pay Reimbursement',
        paymentDate: 'PAYMENT DATE',
        payRefNumber: 'PAYMENT REF NUMBER',
        paidFrom: 'PAID FROM',
        paidBy: 'Paid by',
        paidTime: 'Paid time',
        reqDate: 'Request date',
        approvedBy: 'Approved by',
        approvedTime: 'Approved time',
        paidBy: 'Paid by',
        paidNote: 'Paid note',
        selectAccJournal: 'Select journal account',
        addCategories: 'Add Category',
        nameCategory: 'Category name',
        addCategoryIcon: "Add Category Icon",
        add: 'Add',
        categoryIcon: 'Category Icon',
        listCategory: 'List Category',
        address: 'Address',
        telephone: 'Telephone',
        companyNotif: 'Successfully added.',
        companyNotifUpdate: 'Successfully Updated.',
        ishqAddress: 'HEADQUARTERS ADDRESS',
        location: 'Location',
        useGeofence: 'Use Geofence',
        searchByCompany: 'Search by company',
        questionGeo: 'Use geofence for this Branch ?',
        save: 'Save',
        reqList: 'Request List',
        selectCompany: 'Select Company',
        selectBranch: 'Select Branch',
        selectDepartment: 'Please select Department',

        // employee
        nip: 'NIP',
        managementAccount: "Management Account",
        username: 'username',
        email: 'email',
        employeeInfo: "Employee Info",
        firstName: 'First Name',
        lastName: 'Last Name',
        nickName: 'Nickname',
        identityNumber: 'Indentity Number',
        driverLicense: "Driver's License",
        dob: 'Date Of Birth',
        placeofbirth: 'Place Of Birth',
        bloodType: 'Blood Type',
        selectBlood: 'Please Select Blood Type',
        selectGender: 'Please Select Gender',
        selectMarital: 'Please Select Marital Status',
        singel: 'Single',
        married: 'Married',
        divorced: 'Divorced',
        widowed: 'Widowed',
        gender: 'Gender',
        maritalStatus: 'Marital Status',
        contactInfo: 'Contact Info',
        phone: 'Phone',
        workPhone: 'Work Phone',
        workEmail: 'Work Email',
        currentAddress: 'Current Address',
        emergencyContact: 'Emergency Contact',
        primaryContact: 'Primary Contact',
        secondaryContact: 'Secondary Contact',
        previous: 'Previous',
        next: 'Next',
        education: 'Education',
        lvlOfEducation: 'Level Of Education',
        nameOfUniversity: 'Name of University / School',
        graduatedYear: 'Graduated Year',
        employment: 'Employment',
        jobDesc: 'Job Description',
        leaveQouta: 'Leave Qouta',
        male: 'Male',
        female: 'Female',
        selectRelation: 'Please Select Relation',
        Parent: "Parent",
        Child: "Child",
        Brother: "Brother",
        Sister: "Sister",
        Nephew: "Nephew",
        Niece: "Niece",
        Cousin: "Cousin",
        selectLvlEducation: 'Please Select Level of Education',
        DoctoralDegree: 'Doctoral Degree',
        MastersDegree: "Master's Degree",
        BachelorsDegree: "Bachelor's Degree",
        AssociateDegree: "Associate Degree",
        SeniorHighSchool: "Senior High School",
        selectEmploymentType: "Select Employment Type",

        //SETTINGS
        access: 'Access',
        role: 'Role',
        remove: 'Remove',
        addAccess: 'Add Access',
        startWorkTime: 'Start Work Time',
        endWorkTime: 'End Work Time',
        offDay: 'Off Day',
        Day: 'Day',
        Monday	: 'Monday',
        Tuesday: 'Tuesday',
        Wednesday: 'Wednesday',
        Thursday: 'Thursday',	
        Friday	: "Friday",
        Saturday: 'Saturday',
        Sunday: 'Sunday',
        leavePhoto: 'Leave Photo ?',
        selectRole: 'Please select role',
        letter: "Letter",
        letterNumber: "Letter Number",
        letterDate: "Letter Date",
        letterType: "Letter Type",
        letterPurpose: "Letter Purpose",
        letterStartDate: "Letter Start Date",
        letterEndDate: "Letter End Date",
        letterOfAssignmentAttachments: "Letter Of Assignment Attachments"


    },
}

const i18n = new VueI18n({
    locale: 'id', // set locale
    fallbackLocale: 'en', // set fallback locale
    messages, // set locale messages
});

export default i18n;